/**
 * HelixIcon — Mi6 canon glyph: DNA double helix strand
 * viewBox 0 0 80 80, stroke 1.5px, currentColor
 */
export default function HelixIcon({ className, style }: { className?: string; style?: React.CSSProperties }) {
  return (
    <svg
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      aria-hidden="true"
    >
      {/* Left strand — sinusoidal curve */}
      <path
        d="M30 10 C22 18 22 26 30 34 C38 42 38 50 30 58 C22 66 22 74 30 74"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        fill="none"
      />
      {/* Right strand — sinusoidal curve, phase-shifted */}
      <path
        d="M50 10 C58 18 58 26 50 34 C42 42 42 50 50 58 C58 66 58 74 50 74"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        fill="none"
      />
      {/* Rungs / base pairs */}
      <line x1="30" y1="10" x2="50" y2="10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <line x1="24" y1="22" x2="56" y2="22" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <line x1="30" y1="34" x2="50" y2="34" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <line x1="38" y1="42" x2="42" y2="42" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <line x1="30" y1="58" x2="50" y2="58" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <line x1="24" y1="46" x2="56" y2="46" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <line x1="30" y1="74" x2="50" y2="74" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <line x1="24" y1="70" x2="56" y2="70" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
}
